import { useEffect, useState } from 'react';
import { useCookies } from "react-cookie";
import { useRouter } from "next/router";

type Props = {
    formId: string,
    slug: string
};
export default function useForm(props: Props) {
    const { formId, slug } = props;
    const [cookies] = useCookies(["__gtm_campaign_url"]);
    const [isReady, setIsReady] = useState(false);
    const { push } = useRouter();
    const [x, setX] = useState(false);

    useEffect(() => {
        if (window !== undefined && window.hbspt !== undefined) {
            window.hbspt.forms.create({
                region: "na1",
                portalId: "6847541",
                formId: formId,
                target: ".hubspot-form-block"
            });
        } else {
            setX(!x);
        }
    }, [x]);

    useEffect(() => {
        if (isReady && cookies.__gtm_campaign_url) {
            const url = new URL(cookies.__gtm_campaign_url);
            const urlParams = new URLSearchParams(url.search);
            urlParams.forEach((value, key) => {
                const input: any = document.querySelector(`input[name="${key}"]`);
                if (input) {
                    input.value = value;
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
        }
    }, [isReady]);

    const eventListeners = (event: any) => {
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
            if (event.data.id === formId) {
                setIsReady(true);
            }
        }

        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
            if (event.data.id === formId) {
                push(`/forms/${slug}/thank-you`);
            }
        }
    };

    useEffect(() => {
        window.addEventListener('message', eventListeners);
        return () => {
            window.removeEventListener('message', eventListeners);
        };
    }, []);

    return {
        isReady,
    };
}